// ** React Imports
import { lazy } from 'react';

const WhatsappRoutes = [
  {
    path: 'settings/whatsapp',
    component: lazy(() => import('views/whatsapp')),
  },
];

export default WhatsappRoutes;
